import React, { FC } from 'react';
import { SystemButtonDefault } from '../systemButtonDefaultProps';
import { SystemButtonProps } from '../button.types';
import styles from './warning_button.module.scss';

export const WarningButton: FC<SystemButtonProps> = ({
  children,
  onClick,
  dataName,
  type,
  id,
}) => {
  const commonProps = { className: styles.warning, name: dataName, id };
  if (type === 'submit') {
    return (
      <button type="submit" {...commonProps}>
        {children}
      </button>
    );
  }
  return (
    <button type="button" onClick={onClick} {...commonProps}>
      {children}
    </button>
  );
};

WarningButton.defaultProps = SystemButtonDefault;
